module.exports = __webpack_public_path__ + "static/media/bali-bombings-feature-banner-md@2x.0174e19c.png";